import React from 'react'
import { withPrefix } from 'gatsby';
import Links from '../../links/links';
import s from './canales-info.module.css'

const canalesDeAtencion = [
  {
    keyId: 'one',
    text: (
      <>
        Página Web: <br></br>
        <a
          className="c-orange-0 b underline"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.prima.com.pe/"
        >
          www.prima.com.pe
        </a>
      </>
    )
  },
  {
    keyId: 'two',
    text: (
      <>
        Agencia Virtual para trámites: <br></br>
        <a
          className="c-orange-0 b underline"
          target="_blank"
          rel="noopener noreferrer"
          href="https://miespacio.prima.com.pe/"
        >
          miespacio.prima.com.pe
        </a>
      </>
    )
  },
  {
    keyId: 'three',
    text: (
      <>
        APP móvil
      </>
    )
  },
  {
    keyId: 'six',
    text: (
      <>
        Fono Prima:<br></br>
        <ul className={`bulletList-2 font-family-primary tw-mt-1`}>
          <li className={`tw-mb-1`}>
            Lima: (01) 615-7272
          </li>
          <li>
            Provincias: 0-801-18010 desde un teléfono fijo
          </li>
        </ul>
      </>
    )
  },
  {
    keyId: 'seven',
    text: (
      <>
        Buzón exclusivo para Empresas:<br></br>
        <Links
          className="c-orange-0 b underline"
          to="mailto:servicioempresas@prima.com.pe"
        >
          servicioempresas@prima.com.pe
        </Links>
      </>
    )
  },
]

const CanalesInfo = () => {
  return (
    <div className={`containerWrap`}>
      {/* DESKTOP */}
      <div className='tw-mb-6 tw-mb-10@lg center dn db@lg'>
        <h2 className='font-family-secondary c-turquoise-0 fw-7 tw-f-20 tw-f-24@lg'>
          Ponemos a su disposición los siguientes canales
        </h2>
      </div>

      {/* MOBILE */}
      <div className='bg-white brad-4 shadow tw-mb-10 tw-p-10 db dn@lg'>
        <div className='tw-mb-6 tw-mb-10@lg center'>
          <h2 className='font-family-secondary c-turquoise-0 fw-7 tw-f-20 tw-f-24@lg'>
            Ponemos a su disposición los siguientes canales
          </h2>
        </div>

        <img
          src={withPrefix("/images/jubilacion-y-pension/ico-arrow-down-gris.svg")}
          alt="ico-arrow-down-gris"
          height="25px"
          className="db ml-auto mr-auto tw-mb-10 tw-mb-12@lg"
        />

        <div className='left tw-mt-6'>
          <ul className={`w-100 bulletList-0 font-family-primary tw-f-16 tw-f-16@lg tw-mt-2`}>
            {canalesDeAtencion.map((element) => (
              <li key={element.keyId} className={`tw-mb-2`}>
                {element.text}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* DESKTOP */}
      <div className={`flex direction-column direction-row@lg justify-center`}>
        <div className={`w-100 w-60@lg tw-mb-8 tw-mb-0@lg tw-pb-0 tw-pb-4@lg order-1 order-2@lg z-0 dn db@lg ${s.marginLeftElement}`}>
          <div className='w-60 border@lg border-gray-1@lg brad-4@lg bg-white@lg tw-p-8@lg relative overflow-hidden'>
            <div className='bg-gray--4 tw-py-1 tw-px-3 absolute w-100 left-0 top-0 dn db@lg'>
              <div className='dib brad-4 bg-yellow-0 tw-p-1 tw-mr-1'></div>
              <div className='dib brad-4 bg-white tw-p-1 tw-mr-1'></div>
              <div className='dib brad-4 bg-gray--7 tw-p-1'></div>
            </div>

            <div className='left tw-mt-6'>
              <ul className={`w-100 bulletList-0 font-family-primary tw-f-16 tw-f-16@lg tw-mt-2`}>
                {canalesDeAtencion.map((element) => (
                  <li key={element.keyId} className={`tw-mb-2`}>
                    {element.text}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className={`w-auto w-40@lg relative order-2 order-1@lg z-10 tw-ml-20@lg center`}>
          <img
            src={withPrefix('/images/woman-with-notifications.svg')}
            alt='woman-with-notifications'
            className={`${s.imagenBox1}`}
          />
        </div>
      </div>
    </div>
  )
};

export default CanalesInfo;
